import type { Table } from "@tanstack/react-table";
import type { IProyecto } from "../../../modelos/Proyectos/entidades/IProyecto";
import type { IPais } from "../../../modelos/Ubicacion/entidades/IPais";
import type { ICiudad } from "../../../modelos/Ubicacion/entidades/ICiudad";
import type { IRegional } from "../../../modelos/Regionales/entidades/IRegional";
import type { IZona } from "../../../modelos/Zonas/entidades/IZona";
import type { IFiltroProyecto } from "../../../modelos/Proyectos/entidades/IFiltroProyecto";


export interface ITablaProyectosVistaProps extends IFiltroProyectosVistaProps {
    tabla: Table<IProyecto>;
    abrirModalProyecto: (estadoModal: boolean, proyecto: IProyecto) => void;
    habilitarFiltros: boolean;
    manejarHabilitarFiltros: (habilitar: boolean) => void;
}

export interface IModalproyectoCVProps {
    consultarProyectos: (filtro: IFiltroProyecto) => void;
    abrirModalProyecto: (estadoModal: boolean, proyecto: IProyecto | null) => void;
    estadoModal: boolean;
}

export interface IProyectosCVProps {
    idCliente: string;
    nombreTabla: string;
}

export interface IModalProyectoVistaProps {
    abrir: boolean;
    abrirModalProyecto: (estadoModal: boolean, proyecto: IProyecto) => void;
    // proyectoSeleccionado: IProyecto;
    guardarEditarProyecto: () => void;
    manejarCambioValorProyecto: (campo: keyof IProyecto, valor: IProyecto[keyof IProyecto]) => void;
    entidadesRegistro: IEntidadesRegistroCliente;
    // cargandoModal: boolean;
    // setCargandoModal: React.Dispatch<React.SetStateAction<boolean>>
    agregarError: (campo: keyof IProyecto, error: string) => Promise<void>,
    errores: Partial<Record<keyof IProyecto, string | null>>;
    regexLat: RegExp;
    regexLng: RegExp
}

export const estadoInicialPais: IPais = {
    CodigoISO: '',
    Id: 0,
    Nombre: ''
}

export const estadoInicialRegional: IRegional = {
    Codigo: '',
    Id: 0,
    Nombre: '',
    Pais: estadoInicialPais,
    PaisId: 0
}

export const estadoInicialCiudad: ICiudad = {
    Id: 0,
    Nombre: '',
    PaisId: 0
}

export const estadoInicialZona: IZona = {
    Codigo: '',
    Id: 0,
    Nombre: ''
}

export const estadoInicialProyecto: IProyecto = {
    Id: 0,
    ClienteId: null,
    ContratoId: null,
    Nombre: "",
    NitProyecto: "",
    Direccion: "",
    PaisId: 0,
    CiudadId: 0,
    Latitud: "",
    Longitud: "",
    Telefono: "",
    RegionalId: 0,
    ZonaId: 0,
    Ruta: "",
    CorreoNotificaciones: "",
    Activo: true,        // normalmente en estado inicial lo puedes poner en true o false según tu lógica
    Eliminado: false,    // inicializado en false para evitar inconsistencias
    CreadoUtc: new Date().toISOString(),       // valor inicial en formato ISO
    ActualizadoUtc: new Date().toISOString(),  // valor inicial en formato ISO
    // Ciudad: estadoInicialCiudad,
    // Pais: estadoInicialPais,
    // RegionalDto: estadoInicialRegional,
    // ZonaDto: estadoInicialZona,
    // Cliente: estadoInicialCliente
};

export interface IEntidadesRegistroCliente {
    Paises: IPais[];
    Regionales: IRegional[];
    Zonas: IZona[];
    Ciudades: ICiudad[];
}

export interface IFormularioInformacionProyectoVistaProps {
    guardarEditarProyecto: () => void;
    manejarCambioValorProyecto: (campo: keyof IProyecto, valor: IProyecto[keyof IProyecto]) => void;
    entidadesRegistro: IEntidadesRegistroCliente;
    abrirModalProyecto: (estadoModal: boolean, proyecto: IProyecto) => void;
    agregarError: (campo: keyof IProyecto, error: string) => Promise<void>;
    errores: Partial<Record<keyof IProyecto, string | null>>;
    regexLat: RegExp;
    regexLng: RegExp;
    pantallaCompleta: boolean;
}

export const estadoInicialFiltroProyecto: IFiltroProyecto = {
    NitProyecto: '',
    ProyectoId: undefined,
    PaisId: undefined
}

export interface IFiltroProyectosVistaProps {
    filtro: IFiltroProyecto;
    consultarProyectos: (filtro: IFiltroProyecto) => void;
    limpiarFiltros: () => void;
    manejarCambioFiltroProyecto: (campo: keyof IFiltroProyecto, valor: IFiltroProyecto[keyof IFiltroProyecto]) => void;
    listaProyectos: IProyecto[];
    listaPaises?: IPais[];
}